import React, {useState, useEffect} from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, } from "reactstrap"
import { Row, Col, Form } from "react-bootstrap";
import * as FormFields from "../../../../components/formcomponents"
import { useFormik } from 'formik'
import { ModeOfTransportList } from '../../../../helpers/API/Api';
import { BlueBorderButton, BlueButton } from '../../../../components/buttoncomponents';
function ModeOfTransportModal(props) {
    const [modal, setModal] = useState(true);
    const [tradeEnquiry, setTradeEnquiry] = useState(true)

    const toggle = () => {
        setModal(!modal)
        props.close();
      }

      const formik = useFormik({
        initialValues:
        {
            modeOfTransportID: props.modeOfTransportID != null ? props.modeOfTransportID : 1,
            tradeModeOfTransportValue : 'By Sea'
        },
    })

    const handleSaveEvent = () => {
        props.handleModeOfTransortValue(formik.values)
        toggle(0)
    }
    const handleName = (data) => {
        formik.values.tradeModeOfTransportValue = data
    }
    const handleChange = (e) => {
        console.log(e.target.value, e.target.id)
        formik.values.modeOfTransportID = e.target.value
        formik.values.tradeModeOfTransportValue = e.target.id
    }
    return (
        <Modal isOpen={modal} toggle={toggle} className = 'modal-dialog-custom-width-payments payment-method-modal'>
        <ModalHeader className='px-5 py-4' toggle={toggle}>
            <div className = 'd-flex justify-content-between'>
                <h4 className='font-16 font-weight-600 color-707895'>MODE OF TRANSPORT</h4>
            </div>
        </ModalHeader>
        <ModalBody  className = 'service-request-modal-wrapper'>
            <>
            <div className =''>
                {<ModeOfTransportList onChange={handleChange} name='modeOfTransportID' value={formik.values.modeOfTransportID} tradeEnquiry={tradeEnquiry} handleName={handleName}/>}
            </div>
            </>
        </ModalBody>
            <ModalFooter className='p-2-rem trade_existing_customer_modal_footer d-flex justify-content-start'>
                <span><BlueBorderButton value='Cancel' clickEvent={toggle} width="90px"/></span>
                <span className='pl-10'><BlueButton value='Save' clickEvent={handleSaveEvent} width="90px"/></span>
            </ModalFooter>
        </Modal>
    )
}

export default ModeOfTransportModal